import axios from 'axios';

// Every templates URL lives here, and nowhere else — mirrors src/api/segments.js.
const base = () => `${window.store.event_backend_api}/communications/templates`;

export const listTemplates = () =>
  axios.get(base()).then(({ data }) => data.data);

export const createTemplate = (payload) =>
  axios.post(base(), payload).then(({ data }) => data.data);

export const updateTemplate = (id, payload) =>
  axios.put(`${base()}/${id}`, payload).then(({ data }) => data.data);

// The backend reports a blocked delete as an HTTP 422 (template left intact),
// under a `sequences` key, rather than a 200 carrying an empty-vs-populated
// list — normalized here to the one shape the rest of the app reads, same as
// deleteSegment().
export const deleteTemplate = (id) =>
  axios
    .delete(`${base()}/${id}`)
    .then(({ data }) => ({ referencing_sequences: data.data?.sequences || [] }))
    .catch((error) => {
      const sequences = error?.response?.data?.data?.sequences;
      if (error?.response?.status === 422 && Array.isArray(sequences)) {
        return { referencing_sequences: sequences };
      }
      throw error;
    });
